import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, PopoverController, Events } from 'ionic-angular';
import { SysconfigModel, UserModel } from '../../models/user.model';
import { StorageService } from '../../providers/storage.service';
import { BettingService } from '../../services/betting.service';
import { CurrLotteryModel, PlayModeModel, PlayDetailModel, AlgorithmTypeModel, CachedModel } from '../../models/betting.model';
import { CurrIssue, PlaySelectModel } from '../../models/bettingorder.dto';
import { PageDefault } from '../PageDefault';
import { AlertService } from '../../providers/alert.service';
import { LoaddingService } from '../../providers/loadding.service';
import { GroupByPipe } from 'ng-pipes';
import { BettingOrderHelper, MathAlgorithm } from './bettingorder.helper';
import { AppConfig } from '../../app/app.config';
import { BettingOrderAdd } from './bettingorderadd';
import { BettingChase } from './bettingchase';
import { OpenList } from '../lotteryopen/list/openlist';
import { PlaySelectPage } from './playSelect';
import { RewardPage, UserMoneyPage } from './reward';
import { List } from 'linqts';
import { PlaySelectService } from '../../services/playselect.service';
import { CommonService } from '../../services/common.service';
import { FixedExtend } from '../../config/fixed-extend';
import { DollarsPage } from '../dollars/dollars';
import { BettingParamService } from '../../services/betting.param.service';
import { LotteryService } from '../../services/lottery.service';
import { UserVarifyService } from '../../services/userVarify.service';
import { SuperTabsModule } from 'ionic2-super-tabs';
// import { CookieService } from 'ngx-cookie';

/*
  投注页面
  TQQ 2017-01-06
*/
@Component({
    selector: 'page-bettingorder',
    templateUrl: 'bettingorder.html',
    providers: [BettingService, LotteryService, GroupByPipe, BettingOrderHelper, FixedExtend, UserVarifyService, SuperTabsModule]
})

export class BettingOrderPage {
    AppConfig = AppConfig;
    sysconfig: SysconfigModel = new SysconfigModel();
    currUser: UserModel = new UserModel();
    flagball: boolean = false;
    userInformation = AppConfig.User;
    perMaxReward = false;
    tingPanStatus: boolean = false;
    dollarsPage: any = DollarsPage;
    dollarsParent: any = this;
    currlotteryModeType: number = 0;
    isShowSuperTab: boolean = false;
    constructor(
        private storage: StorageService,
        private navParams: NavParams,
        private bettingService: BettingService,
        private lotteryService: LotteryService,
        private viewCtrl: ViewController,
        private alert: AlertService,
        private groupBy: GroupByPipe,
        private bettinghelper: BettingOrderHelper,
        private navCtrl: NavController,
        private config: AppConfig,
        private loadding: LoaddingService,
        private popCtrl: PopoverController,
        private events: Events,
        private playSelectService: PlaySelectService,
        private common: CommonService,
        private indexExtend: FixedExtend
    ) {

    }

    popTranks = [];
    lotteryCode = this.navParams.get("lotteryCode");
    currPlayDetails;
    initall = new InitParams();
    flagChange: boolean = false;
    selectionResult: string = "";
    load: any;
    soundState: any;
    playOfficialModes = {
        PlayModes: [],
        PlayModesName: "传统玩法",
        PlayModeType: 0
    };
    playDollarModes = {
        PlayModes: [],
        PlayModesName: "信用玩法",
        PlayModeType: 1
    };
    moneyModel = [
        { "id": 0, "value": 1, "name": "元" },
        { "id": 1, "value": 0.1, "name": "角" },
        { "id": 2, "value": 0.01, "name": "分" },
        { "id": 3, "value": 0.001, "name": "厘" }
    ];
    changeFalg: boolean = true;
    historyPlay;
    cacheds: CachedModel[] = [];
    currPlayDetaileCode;
    getplaydetail;
    getplaymodename;
    pageReward: any = 0;
    userBonus: any = 0;
    realBettingNum: any = 1;
    IssueMaxProfit: number = 0;
    KqIssueMaxProfit: number = 0;
    historyTimer: any = "";

    ionViewDidLoad() {
        this.sysconfig = this.config.getSysConfig();
        this.perMaxReward = this.sysconfig.PerMaxReward > 0 ? true : false;
        this.IssueMaxProfit = this.sysconfig.IssueMaxProfit;
        this.KqIssueMaxProfit = this.sysconfig.KqIssueMaxProfit;
        this.currUser = this.config.getCurrentUser();
        this.getLottery();
        //开奖
        //TQQ 2017-02-23
        this.events.subscribe("LotteryOpenCode", datas => {
            let data = datas[0];
            if (data.LotteryCode === this.lotteryCode) {
                let has = false;
                this.initall.historyList.forEach(h => {
                    if (h.IssueNo == data.IssueNo) {
                        has = true;
                    }
                });
                if (!has) {
                    this.appendCanada28Sum(data);
                    this.initall.historyList.unshift(data);
                    this.initall.openIssueno = this.initall.historyList[0].IssueNo;
                    this.initall.openNum = this.initall.historyList[0].LotteryOpenNo;
                    this.initall.historyList.pop();
                    if (this.initall.OpenWarn == this.initall.WarnUp) {
                        this.config.createNumMp3(this.initall.openNum);
                    }
                }
            }
        });
        this.playSelectService.playSelect.subscribe((res: PlaySelectModel) => {
            if (!this.changeFalg)
                return;
            else {
                if (res && res.playDetail) {
                    let detailName = this.popTranks["playDetailName"] ? this.popTranks["playDetailName"] : this.initall.currPlayDetail.LotteryPlayDetailName;
                    let playMode = res["playMode"];
                    let playDetail = res["playDetail"] ? res["playDetail"] : this.initall.currPlayDetail;
                    this.initall.currlottery.PlayMode = playMode;
                    this.selectionResult = playMode.LotteryPlayModeName + "---" + (res["playDetailName"] ? res["playDetailName"] : detailName);
                    this.initPlayDetail(playDetail);
                }
            }
            this.changeFalg = true;
        });
        this.soundState = this.storage.read('openSound');
        if (this.soundState == 'on') {
            this.initall.OpenWarn = this.initall.WarnUp;
        } else {
            this.initall.OpenWarn = this.initall.WarnOff;
        }
        this.cacheds = this.storage.read<CachedModel[]>("cachedPlay" + this.lotteryCode);
    }

    openLiRun(){
        let limit = this.currlotteryModeType == 1 ? this.KqIssueMaxProfit : this.IssueMaxProfit;
        this.alert.showAlert(`单期最高利润（利润=总奖金-总投注）限额${limit / 10000}万元，超出按${limit / 10000}万元计算，超出的利润无效并清0`,'温馨提示',false);
    }

    ionViewDidLeave() {
        this.lotteryCode = "";
        clearInterval(this.config.setIntervalid);
        this.events.unsubscribe("LotteryOpenCode");
        clearInterval(this.historyTimer);
    }

    ionViewWillUnload() {
        clearInterval(this.historyTimer); 
    }

    //首次加载/返回
    //TQQ 2017-02-10
    ionViewDidEnter() {
        this.lotteryCode = this.navParams.get("lotteryCode");
        let lastCtrl = this.navCtrl.last();
        if ((lastCtrl.component == BettingOrderAdd || lastCtrl.component == BettingChase) && lastCtrl && lastCtrl.data.isBetting) {
            this.initall.BetDatas = [];
        }
        this.getIssue();
        this.historyTimer = setInterval(() => {
            this.getHistory();
        }, 5000);
    }
    //获取彩票所需要的所有数据
    //TQQ 2017-01-06
    getLottery() {
        this.isShowSuperTab = false;
        this.load = this.loadding.showLoding();
        let o = this.storage.read<CurrLotteryModel>("lottery" + this.lotteryCode);
        if (this.isCreditOnlyLottery()) {
            o = null;
            this.storage.remove("lottery" + this.lotteryCode);
        }
        if (o == null) {
            this.bettingService.getLottery(this.lotteryCode).then(s => {
                if (s) {
                    this.storage.write("lottery" + this.lotteryCode, s);
                    this.prepareLottery(s);
                } else {
                    this.initall.isOk = false;
                    this.loadding.closeLoading(this.load);
                    this.alert.showAlert("暂无投注信息");
                    this.viewCtrl.dismiss();
                }
            }).catch(s => {
                clearInterval(this.historyTimer);
            });
        } else {
            this.prepareLottery(o);
        }
    }

    prepareLottery(lottery) {
        if (this.lotteryCode != "95000") {
            this.init(lottery);
            return;
        }
        let cachedSettings = this.storage.read<any>("markSixInfo");
        if (cachedSettings) {
            this.applyMarkSixSettings(cachedSettings);
            this.init(lottery);
            return;
        }
        this.lotteryService.getSixSetting().then((settings) => {
            if (settings) {
                this.storage.write("markSixInfo", settings);
                this.applyMarkSixSettings(settings);
            }
            this.init(lottery);
        }).catch(() => this.init(lottery));
    }

    applyMarkSixSettings(settings) {
        let year = Number(settings.LiuhecaiHXDate);
        AppConfig.markSixYear = year > 1900 ? year : new Date().getFullYear();
        AppConfig.markSixPrevYear = AppConfig.markSixYear - 1;
        let issues = settings.LotteryIssues || [];
        let issueSetting = issues.find((item) => item.LotteryCode == this.lotteryCode);
        AppConfig.markSixStartIssue = issueSetting ? issueSetting.StartIssue : "";
    }

    getMarkSixColor(number) {
        return this.bettinghelper.getLetteryMarkSixColor(number).color;
    }

    init(o) {
        this.initall.currlottery = o;
        this.initall.rewardUp = this.initall.currlottery.RewardUp ? this.initall.currlottery.RewardUp : this.sysconfig.RewardUp;
        this.initall.rewardDown = this.initall.currlottery.RewardDown ? this.initall.currlottery.RewardDown : this.sysconfig.RewardDown;
        this.initall.baseReward = this.sysconfig.BasicReward + (this.initall.rewardUp - this.sysconfig.RewardUp);
        this.getHistory();
        this.playClassify(o);
        if (this.currlotteryModeType == 0 && this.playOfficialModes.PlayModes.length > 0) {
            this.cacheds = this.storage.read<CachedModel[]>("cachedPlay" + this.lotteryCode);
            this.cacheds = this.cacheds ? this.cacheds : [];
            this.initall.currlottery.PlayMode = this.playOfficialModes.PlayModes.find(s => s.IsSelect)
                || this.playOfficialModes.PlayModes[0];
            if (this.cacheds.length > 0) {
                let cachedPlayMode = this.playOfficialModes.PlayModes.find(s =>
                    s.LotteryPlayModeCode == this.cacheds[0].PlayMode.LotteryCode);
                if (cachedPlayMode) {
                    this.initall.currlottery.PlayMode = cachedPlayMode;
                    this.currPlayDetaileCode = this.cacheds[0].PlayDetail.LotteryPlayDetailCode;
                    this.initPlayDetail(this.cacheds[0].PlayDetail);
                } else {
                    this.initPlayDetail(this.initall.currlottery.PlayMode.PlayDetails[0]);
                }
            } else {
                this.initPlayDetail(this.initall.currlottery.PlayMode.PlayDetails[0]);
            }
        }
        if (this.currlotteryModeType == 1 && this.playDollarModes.PlayModes.length > 0) {
            this.initall.currlottery.PlayMode = this.playDollarModes.PlayModes.find(s => s.IsSelect)
                || this.playDollarModes.PlayModes[0];
            if (this.initall.currlottery.PlayMode.PlayDetails
                && this.initall.currlottery.PlayMode.PlayDetails.length > 0) {
                this.initPlayDetail(this.initall.currlottery.PlayMode.PlayDetails[0]);
                this.initBonusMode();
            }
        }
        if (this.currlotteryModeType == 0 && this.initall.currlottery && this.initall.currlottery.PlayMode) {
            let cachedplaydetail = this.initall.currlottery.PlayMode.PlayDetails[0];
            let currPlayDetail = cachedplaydetail;
            let currDetailName = cachedplaydetail.LotteryPlayDetailName;
            let playGroup = cachedplaydetail.PlayGroup;
            let tracks = {
                playMode: this.initall.currlottery.PlayMode,
                playDetailName: currDetailName,
                playDetail: currPlayDetail,
                PlayGroup: playGroup,
            };
            this.playSelectService.setPlaySelectModel(tracks);
            this.initBonusMode();
        }
        this.isShowSuperTab = true;
    }

    isCreditOnlyLottery() {
        return BettingParamService.isCreditOnlyLottery(this.lotteryCode);
    }

    //按玩法类型拆分官方盘与信用盘
    playClassify(lottery) {
        let playModes = lottery.PlayModes || [];
        if (playModes.length == 0 && lottery.PlayMode) {
            playModes = [lottery.PlayMode];
        }
        this.playOfficialModes.PlayModes = playModes.filter(s => s["PlayModeType"] != 1);
        this.playDollarModes.PlayModes = playModes.filter(s => s["PlayModeType"] == 1);

        // 加拿大28默认进入回本玩法，super-tabs 默认选中第一个标签
        if (this.lotteryCode == "50001") {
            let returnPrincipalIndex = this.playDollarModes.PlayModes.findIndex(s =>
                s.LotteryPlayModeName && s.LotteryPlayModeName.indexOf("回本") > -1);
            if (returnPrincipalIndex > 0) {
                let returnPrincipalMode = this.playDollarModes.PlayModes.splice(returnPrincipalIndex, 1)[0];
                this.playDollarModes.PlayModes.unshift(returnPrincipalMode);
            }
        }

        if (this.lotteryCode == "95000") {
            this.playDollarModes.PlayModes = this.playDollarModes.PlayModes.filter(s =>
                ["连码", "合肖", "全不中"].indexOf(s.LotteryPlayModeName) == -1);
        }
        let savedMode = Number(this.storage.readString("playModeType"));
        if (this.isCreditOnlyLottery()
            || (this.playOfficialModes.PlayModes.length == 0 && this.playDollarModes.PlayModes.length > 0)) {
            this.currlotteryModeType = 1;
        } else if (savedMode == 1 && this.playDollarModes.PlayModes.length > 0) {
            this.currlotteryModeType = 1;
        } else {
            this.currlotteryModeType = 0;
        }
        this.storage.writeString("playModeType", this.currlotteryModeType + "");
    }

    //官方玩法与信用玩法切换
    lotterySwitch() {
        if (this.isCreditOnlyLottery()) {
            this.currlotteryModeType = 1;
            return;
        }
        let nextMode = this.currlotteryModeType == 0 ? 1 : 0;
        if (nextMode == 1 && this.playDollarModes.PlayModes.length == 0) {
            return;
        }
        if (nextMode == 0 && this.playOfficialModes.PlayModes.length == 0) {
            return;
        }
        this.currlotteryModeType = nextMode;
        this.storage.writeString("playModeType", this.currlotteryModeType + "");
        if (this.currlotteryModeType == 0) {
            let officialPlayMode = this.playOfficialModes.PlayModes.find(s => s.IsSelect)
                || this.playOfficialModes.PlayModes[0];
            this.initall.currlottery.PlayMode = officialPlayMode;
            let cachedPlay = (this.storage.read<CachedModel[]>("cachedPlay" + this.lotteryCode) || [])[0];
            let playDetail = cachedPlay && cachedPlay.PlayMode.LotteryCode == officialPlayMode.LotteryPlayModeCode
                ? cachedPlay.PlayDetail
                : officialPlayMode.PlayDetails[0];
            this.initPlayDetail(playDetail);
            this.initBonusMode();
        }
    }

    hasBothPlayModes() {
        return this.playOfficialModes.PlayModes.length > 0
            && this.playDollarModes.PlayModes.length > 0;
    }

    onTabSelect(tab) {
    }

    //获取当前期号，上期期号，当前期号结束剩余时间
    //TQQ 2017-01-06
    getIssue() {
        clearInterval(this.config.setIntervalid);
        if (!this.initall.isOk) {
            this.loadding.closeLoading(this.load);
            return;
        }
        this.bettingService.getIssue(this.lotteryCode).then(s => {
            this.initall.currIssue = s;
            if (!s || s.CurrentIssueNo == "-1") {
                this.tingPanStatus = true;
                this.initall.formatRemain = "--:--:--";
                return;
            }
            this.tingPanStatus = false;
            this.config.setIntervalid = setInterval(s => {
                this.initall.currIssue.RemainTime -= 1000;
                this.issueTimerCallback(this.initall.currIssue.RemainTime);
                if (this.initall.currIssue.RemainTime == 1000 && this.initall.OpenWarn == this.initall.WarnUp) {
                    this.config.createMp3();
                }
            }, 1000);
            this.config.setTitle(this.initall.currlottery.LotteryName);
            // this.loadding.closeLoading(this.load);
        }).catch(c => {
            this.alert.showAlert("出现错误");
            this.loadding.closeLoading(this.load);
            this.storage.remove("lottery" + this.lotteryCode);
            this.viewCtrl.dismiss();
        });
    }

    //开奖倒计时
    issueTimerCallback(time) {
        if (time >= 0) {
            let t = PageDefault.formatTime(time / 1000);
            this.initall.formatRemain = t.join(':');
        } else {
            clearInterval(this.config.setIntervalid);
            this.alert.showAlert("您好，" + this.initall.currIssue.CurrentIssueNo + "期已截止，投注时请确认您选择的期号。");
            this.getIssue();
        }
    }

    //获取彩票开奖历史
    //TQQ 2017-01-06
    getHistory() {
        this.bettingService.getHistory(this.lotteryCode).then(s => {
            this.normalizeCanada28History(s);
            this.initall.historyList = s;
            if (s && s.length > 0) {
                this.initall.openIssueno = s[0].IssueNo;
                this.initall.openNum = s[0].LotteryOpenNo;
                this.flagball = (this.initall.openNum.length < 15) ? false : true;
            }
            this.loadding.closeLoading(this.load);
        }).catch(c => {
            this.loadding.closeLoading(this.load);
        });
    }

    appendCanada28Sum(item) {
        if (!item || (this.lotteryCode != "50001" && this.lotteryCode != "90002")) {
            return;
        }
        let numbers = item.LotteryOpenNo.split(",");
        if (numbers.length == 3) {
            let sum = numbers.reduce((total, num) => total + parseInt(num, 10), 0);
            item.LotteryOpenNo += "," + sum;
            item.sumOpenNum = sum;
        }
    }

    normalizeCanada28History(history) {
        if (history && (this.lotteryCode == "50001" || this.lotteryCode == "90002")) {
            history.forEach(item => this.appendCanada28Sum(item));
        }
        return history;
    }

    //近期开奖
    //TQQ 2017-02-14
    openList() {
        this.initall.isShowOpen = !this.initall.isShowOpen;
    }

    //查看更多
    //TQQ 2017-02-14
    lookmore() {
        this.initall.isShowOpen = false;
        this.navCtrl.push(OpenList, { lotteryCode: this.initall.currlottery.LotteryCode, lotteryName: this.initall.currlottery.LotteryName });
    }

    //上拉图标点击
    //chen 2012-02-23
    close() {
        this.flagChange = false;
    }

    //初始化玩法明细
    //TQQ 2017-01-16
    initPlayDetail(playDetail: PlayDetailModel) {
        this.initall.initDetailPars();
        this.initall.currPlayDetail = playDetail;
        this.initall.currAlgorithmType = playDetail.Algorithm.AlgorithmType;
        let playmodel = this.initall.currlottery.PlayMode;
        this.selectionResult = playmodel.LotteryPlayModeName + "---" + playDetail.LotteryPlayDetailName;
        this.getplaydetail = playDetail.LotteryPlayDetailName;
        this.getplaymodename = playmodel.LotteryPlayModeName;
        this.storage.writeString("PlayModeName", playmodel.LotteryPlayModeName + "---" + playDetail.LotteryPlayDetailName);
        // 选位
        this.initall.isrx = this.initall.currlottery.LotteryTypeCode == "01" && this.initall.currlottery.PlayMode.LotteryPlayModeName.indexOf("任选") >= 0;
        var checklist = this.bettinghelper.getCheckName(this.initall.currlottery.LotteryTypeCode, this.initall.isrx);
        for (var j in checklist) {
            this.initall.checkList.push({ name: checklist[j], checked: checklist.length - playDetail.Algorithm.BetNumLength <= parseInt(j) });
        }
        //键盘
        if (playDetail.Algorithm.AlgorithmType.PickMode == '01') {
            var medianlist = this.bettinghelper.getMedianList(playDetail.AlgorithmCode, playDetail.Algorithm.AlgorithmTypeCode);
            var commandlist = this.bettinghelper.getCommandList(playDetail.Algorithm.AlgorithmTypeCode);
            var numlist = this.bettinghelper.getNumList(playDetail.Algorithm.AlgorithmTypeCode, playDetail.Algorithm.BetNumLength, this.lotteryCode);
            if (this.initall.currlottery.LotteryTypeCode === "07") {
                commandlist = [];
            }
            var t = 0;
            var checked = false;
            for (var j in medianlist) {
                let i = parseInt(j);
                if (this.initall.currlottery.PlayMode.LotteryPlayModeName.indexOf("任选") < 0) {
                    this.initall.isrx = false;
                    if (this.initall.currlottery.PlayMode.LotteryPlayModeName.indexOf("前") >= 0 || playDetail.LotteryPlayDetailName.indexOf("前") >= 0) {
                        checked = this.initall.currPlayDetail.Algorithm.BetNumLength > i;
                    } else if (this.initall.currlottery.PlayMode.LotteryPlayModeName.indexOf("中") >= 0) {
                        if (medianlist.length <= playDetail.Algorithm.BetNumLength || [1, 2, 3].indexOf(i) >= 0) {
                            checked = true;
                        } else {
                            checked = false;
                        }
                    } else {
                        checked = medianlist.length - playDetail.Algorithm.BetNumLength <= i;
                    }
                } else {
                    this.initall.isrx = true;
                    checked = true;
                }
                if (!checked) {
                    t++;
                }
                if (checked) {
                    this.initall.data_sel.push([]);
                    this.initall.medianList.push({ name: medianlist[i], checked: checked, index: i - t });//, index: i
                }
            }

            for (var i in this.initall.medianList) {
                var n = numlist;

                if (Array.isArray(numlist[i])) {
                    n = numlist[i];
                }
                var num = [];
                for (var nn in n) {
                    num.push({ name: n[nn], checked: false, place: i });
                }
                this.initall.numList.push(num);

                if (this.initall.numList[0].length <= 11 ||
                    this.lotteryCode == '30012' ||
                    this.lotteryCode == '30013' ||
                    this.lotteryCode == '30014' ||
                    this.lotteryCode == '30015' ||
                    this.lotteryCode == '30016') {
                    var commd = [];
                    if (medianlist[i] != "胆码") {
                        for (var d in commandlist) {
                            commd.push({ name: commandlist[d], checked: false });
                        }
                        this.initall.commandList.push(commd);
                    }
                } else {
                    this.initall.commandList = [];
                }
            }

        } else {
            this.initall.medianList = [];
            this.initall.numList = [];
        }
        this.setRewards(this.initall.YuanJiaoFen);
        // this.flagChange = false;

    }

    //初始化返点调节
    //TQQ 2017-01-18
    initBonusMode() {
        var canAdjust = (((this.currUser.Bonus - this.sysconfig.AdjustMinBonus) / this.sysconfig.BonusGruduation) * this.sysconfig.PerGraduation + this.initall.baseReward);
        var canAdjustDown = (this.initall.baseReward - ((this.sysconfig.AdjustMaxBonus - this.currUser.Bonus) * this.sysconfig.PerGraduation / this.sysconfig.BonusGruduation));

        if (canAdjust <= this.initall.rewardUp) {
            this.initall.maxnum = canAdjust;
        } else {
            this.initall.maxnum = this.initall.rewardUp;
        }
        if (canAdjustDown <= this.initall.rewardDown) {
            this.initall.minnum = this.initall.rewardDown;
        } else {
            this.initall.minnum = canAdjustDown;
        }
        if (this.initall.YuanJiaoFen == 0.1) {
            if (this.sysconfig.JiaoMaxMode < canAdjust) {
                this.initall.maxnum = this.sysconfig.JiaoMaxMode;
            }
        } else if (this.initall.YuanJiaoFen == 0.01) {
            if (this.sysconfig.FenMaxMode < canAdjust) {
                this.initall.maxnum = this.sysconfig.FenMaxMode;
            }
        }
        var adjust = 0;
        var value = this.initall.maxnum + this.sysconfig.PerGraduation * adjust;
        this.initall.AdjustReward = (value - this.initall.baseReward) / this.sysconfig.PerGraduation;
        var increaseBonus = this.sysconfig.BonusGruduation * (this.initall.baseReward - value) / this.sysconfig.PerGraduation;
        var currentBonus = this.currUser.Bonus + increaseBonus;
        currentBonus = currentBonus > this.sysconfig.AdjustMaxBonus ? this.sysconfig.AdjustMaxBonus : currentBonus;
        currentBonus = currentBonus < this.sysconfig.AdjustMinBonus ? this.sysconfig.AdjustMinBonus : currentBonus;

        this.initall.BonusMode = [parseFloat(currentBonus.toFixed(2)), this.initall.currlottery.LotteryTypeCode == "02" ? value * 0.99 : value];

        this.initall.rangeValue = this.initall.maxnum;

        this.setRewards(this.initall.YuanJiaoFen);
        
    }

    //奖金调节
    //TQQ 2017-01-18
    rangeChange() {
        var increaseBonus = this.sysconfig.BonusGruduation * (this.initall.baseReward - this.initall.rangeValue) / this.sysconfig.PerGraduation;
        var currentBonus = this.currUser.Bonus + increaseBonus;
        currentBonus = currentBonus > this.sysconfig.AdjustMaxBonus ? this.sysconfig.AdjustMaxBonus : currentBonus;
        currentBonus = currentBonus < this.sysconfig.AdjustMinBonus ? this.sysconfig.AdjustMinBonus : currentBonus;
        this.initall.BonusMode = [parseFloat(currentBonus.toFixed(2)), this.initall.currlottery.LotteryTypeCode == "02" ? (this.initall.rangeValue * 0.99) : this.initall.rangeValue];
        this.initall.AdjustReward = (this.initall.rangeValue - this.initall.baseReward) / this.sysconfig.PerGraduation;
        this.setRewards(this.initall.YuanJiaoFen);
        this.getPageReward();
    }

    //数字点击事件
    //TQQ 2017-01-18
    numClick(medianck, num, parenti) {
        if (medianck) {
            var o = this.initall.numList[parenti].find(s => s.name == num.name);
            if (o.checked) {
                this.unSelectNum(o);
            } else {
                this.selectNum(o);
            }
        }
    }

    //全选等按钮的点击事件
    //TQQ 2017-01-18
    commandClick(b, v, i) {
        if (b) {
            var len = this.initall.numList[i].length;
            switch (v.name) {
                case "全":
                    this.initall.numList[i].forEach(s => {
                        this.selectNum(s);
                    });
                    break;
                case "清":
                    this.initall.numList[i].forEach(s => {
                        this.unSelectNum(s);
                    });
                    break;
                case "单":
                    this.initall.numList[i].forEach(s => {
                        if (parseInt(s.name) % 2 == 1) {
                            this.selectNum(s);
                        } else {
                            this.unSelectNum(s);
                        }
                    });
                    break;
                case "双":
                    this.initall.numList[i].forEach(s => {
                        if (parseInt(s.name) % 2 == 0) {
                            this.selectNum(s);
                        } else {
                            this.unSelectNum(s);
                        }
                    });
                    break;
                case "大":
                    for (var j in this.initall.numList[i]) {
                        if (parseInt(j) >= Math.floor(len / 2)) {
                            this.selectNum(this.initall.numList[i][j]);
                        } else {
                            this.unSelectNum(this.initall.numList[i][j]);
                        }
                    }
                    break;
                case "小":
                    for (var k in this.initall.numList[i]) {
                        if (parseInt(k) < Math.floor(len / 2)) {
                            this.selectNum(this.initall.numList[i][k]);
                        } else {
                            this.unSelectNum(this.initall.numList[i][k]);
                        }
                    }
                    break;
            }
        }
    }

    //选中数字
    //TQQ 2017-01-18
    selectNum(num) {
        if (num.checked) {
            return;
        }
        this.initall.data_sel[num.place].push(num.name);
        num.checked = true;
        var unplace = 1 - num.place;
        if (this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == "DT"
            || this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == "RXDT"
            || this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == "bthdt") {

            var danlen = this.initall.data_sel[0].length;
            var sellen = this.initall.currPlayDetail.Algorithm.BetNumLength;
            if (danlen + 1 > sellen) {
                var shift = this.initall.data_sel[0].shift();
                this.initall.numList[0][parseInt(shift) - 1].checked = false;
            }
            unplace = 1 - num.place;
            if (this.initall.data_sel[unplace].find(s => s == num.name)) {
                this.initall.numList[unplace][parseInt(num.name) - 1].checked = false;
                var index = this.initall.data_sel[unplace].indexOf(num.name);
                if (index > -1) {
                    this.initall.data_sel[unplace].splice(index, 1);
                }
            }
        } else if (this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == "ZUBD") {

            for (var i in this.initall.numList[0]) {
                var item = this.initall.numList[0][i];
                if (item.name != num.name) {
                    item.checked = false;
                    var index = this.initall.data_sel[0].indexOf(item.name);
                    if (index > -1) {
                        this.initall.data_sel[0].splice(index, 1);
                    }
                }
            }
        } else if (this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == "0705") {
            this.initall.numList[unplace][parseInt(num.name.substr(0, 1)) - 1].checked = false;
            var index = this.initall.data_sel[unplace].indexOf(this.initall.numList[unplace][parseInt(num.name.substr(0, 1)) - 1].name);
            if (index > -1) {
                this.initall.data_sel[unplace].splice(index, 1);
            }
        }
        this.getDragonRewordByBettingContent();
        var par = {
            dataSel: this.initall.data_sel,
            lotteryTypeCode: this.initall.currlottery.LotteryTypeCode,
            checklist: this.initall.checkList,
            algorithmTypeCode: this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode,
            betNumLength: this.initall.currPlayDetail.Algorithm.BetNumLength,
            isrx: this.initall.isrx
        }
        this.initall.BettingCount = this.bettinghelper.getCurrentLotteryBetCount(par);
        this.getPageReward();
    }

    //取消选中的数字
    //TQQ 2017-01-18
    unSelectNum(num) {
        if (num.checked) {
            num.checked = false;
            var index = this.initall.data_sel[num.place].indexOf(num.name);
            if (index > -1) {
                this.initall.data_sel[num.place].splice(index, 1);
            }
            this.getDragonRewordByBettingContent();
            var par = {
                dataSel: this.initall.data_sel,
                lotteryTypeCode: this.initall.currlottery.LotteryTypeCode,
                checklist: this.initall.checkList,
                algorithmTypeCode: this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode,
                betNumLength: this.initall.currPlayDetail.Algorithm.BetNumLength,
                isrx: this.initall.isrx
            }
            this.initall.BettingCount = this.bettinghelper.getCurrentLotteryBetCount(par);
            this.getPageReward();
        }
    }
    /**
    * 根据选中的投注内容计算玩法最高和最低奖金
    *
    */
    getDragonRewordByBettingContent() {
        let arrReward = [];
        this.initall.currPlayDetail.PlayDetailAttacheds.forEach(s => {
            var reward = this.getAttachedReward(s);
            arrReward.push(reward);
        })
        this.filterBonus(arrReward);
    }

    //删除重复号
    //TQQ 2017-01-18
    removeTickNumber() {
        var number = this.initall.BetBoxNum.split(/(?:\s*,+\s*)|(?:\s*\|+\s*)|(?:\s*\s+\s*)/);
        var result = [];
        if (this.initall.currAlgorithmType.PickMode == "02") {
            number = this.initall.BetBoxNum.split(/\n|;|,/);
            let tmp = {};
            number.forEach(n => {
                if (!tmp[n.replace(/\s/g, "")]) {
                    tmp[n.replace(/\s/g, "")] = n;
                }
            });
            for (var t in tmp) {
                result.push(tmp[t].trim());
            }
        } else {
            number.forEach(n => {
                if (result.indexOf(n) > -1) {
                    return;
                }
                result.push(n);
            });
        }

        var tt = this.bettinghelper.getErrorBettingNumber(result.join(','), this.initall.currlottery.LotteryTypeCode, this.initall.currPlayDetail);

        this.initall.BetBoxNum = tt.correct.join(',');
        this.onBetBoxChange();
    }

    //清空号码
    //TQQ 2017-01-18
    emptyNumber() {
        this.initall.BetBoxNum = "";
        this.onBetBoxChange();
    }


    //位置change事件
    //TQQ 2017-03-03
    checkListClick() {
        if (this.initall.currPlayDetail.Algorithm.AlgorithmType.PickMode == "01") {
            var par = {
                dataSel: this.initall.data_sel,
                lotteryTypeCode: this.initall.currlottery.LotteryTypeCode,
                checklist: this.initall.checkList,
                algorithmTypeCode: this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode,
                betNumLength: this.initall.currPlayDetail.Algorithm.BetNumLength,
                isrx: this.initall.isrx
            }
            this.initall.BettingCount = this.bettinghelper.getCurrentLotteryBetCount(par);
            this.getPageReward();
        } else {
            this.onBetBoxChange();
        }
    }

    onBetBoxChange() {
        try {
            var cnt = this.bettinghelper.validateBettingNumber(this.initall.BetBoxNum, this.initall.currlottery.LotteryTypeCode, this.initall.currPlayDetail);
            var checkedlength = 0;// this.checkList.find(s => s.checked).length;
            let list = new List(this.initall.checkList);
            checkedlength = list.Where(s => s.checked).ToArray().length;
            if (this.initall.isrx && checkedlength > 0) {
                cnt *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, this.initall.currPlayDetail.Algorithm.BetNumLength);
            }
            this.initall.BettingCount = cnt;
            this.getPageReward();
        } catch (e) {
            this.initall.BettingCount = 0;
            this.getPageReward();
        }
    }

    //龙虎和特殊号多奖金计算返回
    filterBonus(arrReward) {
        if (this.initall.currAlgorithmType.AlgorithmTypeName === "龙虎") {
            // this.initall.Reward = this.initall.Reward.sort(this.customSort);
            if (this.initall.data_sel && this.initall.data_sel[0]) {
                if (this.initall.data_sel[0].join(',').indexOf('和') > -1) {
                    this.initall.ShowReward = Math.max.apply(null, arrReward);
                } else {
                    if (arrReward && arrReward.length == 4) {
                        this.initall.ShowReward = arrReward[1];
                    }
                }
            }
            if (this.initall.data_sel[1] && this.initall.data_sel[0] && this.initall.data_sel[0].length === 0) {
                this.initall.ShowReward = Math.min.apply(null, arrReward);
            }
        }
        if (this.initall.currAlgorithmType.AlgorithmTypeName === "特殊号") {
            if (this.initall.data_sel && this.initall.data_sel[0]) {
                if (this.initall.data_sel[0].join(',').indexOf('豹子') > -1) {
                    return this.initall.ShowReward = Math.max.apply(null, arrReward);
                }
                if (this.initall.data_sel[0].join(',').indexOf('顺子') > -1) {
                    return this.initall.ShowReward = arrReward[1];
                }
                if (this.initall.data_sel[0].join(',').indexOf('对子') > -1) {
                    return this.initall.ShowReward = Math.min.apply(null, arrReward);
                }
            }
        }
    }


    getPageReward() {
        this.initall.Multiple = this.initall.Multiple ? this.initall.Multiple : 0;
        this.realBettingNum = 1;
        if (this.lotteryCode == '30012' ||
            this.lotteryCode == '30013' ||
            this.lotteryCode == '30014' ||
            this.lotteryCode == '30015'
        ) {
            let MaxBettingNum = 1;
            switch (this.lotteryCode) {
                case '30013': // 快乐8
                    MaxBettingNum = 20;
                    break;
                case '30012': //双色球
                    MaxBettingNum = this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == 'HQRX' ? 6 : 1;
                    break;
                case '30014': //七乐彩
                    MaxBettingNum = this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == 'HQRX' ? 7 : 1;
                    break;
                case '30015': //超级大乐透
                    MaxBettingNum = this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == 'HQRX' ? 5 : 2;
                    break;
            }
            this.realBettingNum = this.initall.BettingCount > MaxBettingNum ? MaxBettingNum : this.initall.BettingCount;
            this.pageReward = this.initall.BettingCount == 0 ? 0 : this.indexExtend.accMul(this.indexExtend.accMul(this.initall.ShowReward, this.initall.Multiple), this.realBettingNum);
            this.userBonus = this.initall.BettingCount == 0 ? 0 : (this.indexExtend.accSub(this.indexExtend.accMul(this.indexExtend.accMul(
                this.initall.ShowReward, this.initall.Multiple), this.realBettingNum),
                (this.indexExtend.accMul(this.indexExtend.accMul(
                    this.indexExtend.accMul(this.initall.BettingCount, this.initall.YuanJiaoFen),
                    this.sysconfig.PerBettingPrice), this.initall.Multiple)
                )))
        } else {
            this.realBettingNum = 1;
            this.pageReward = this.initall.BettingCount == 0 ? 0 : this.indexExtend.accMul(this.initall.ShowReward, this.initall.Multiple);
            this.userBonus = this.initall.BettingCount == 0 ? 0 : (this.indexExtend.accSub(this.indexExtend.accMul(this.indexExtend.accMul(
                this.initall.ShowReward, this.initall.Multiple), this.realBettingNum),
                (this.indexExtend.accMul(this.indexExtend.accMul(
                    this.indexExtend.accMul(this.initall.BettingCount, this.initall.YuanJiaoFen),
                    this.sysconfig.PerBettingPrice), this.initall.Multiple)
                )))
        }

        if (
            this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == 'HQDWD' ||
            this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == '0311' ||
            this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == '0112'
        ) {
            const _betDataList = this.initall.data_sel;
            let _selectLength = 0;
            if (_betDataList.length > 0) {
                _betDataList.forEach((item) => {
                    if (item.length) {
                        _selectLength = _selectLength + 1;
                    }
                });
            }
            this.realBettingNum = _selectLength;
            const _bettingMoney = this.indexExtend.accMul(
                this.initall.ShowReward,
                _selectLength
            );

            this.pageReward = this.indexExtend.accMul(_bettingMoney, this.initall.Multiple);
            this.userBonus = this.initall.BettingCount == 0 ? 0 :
                (
                    this.indexExtend.accSub(
                        this.indexExtend.accMul(
                            this.indexExtend.accMul(this.initall.ShowReward, this.initall.Multiple), _selectLength
                        ),
                        (this.indexExtend.accMul(
                            this.indexExtend.accMul(
                                this.indexExtend.accMul(
                                    this.initall.BettingCount,
                                    this.initall.YuanJiaoFen
                                ),
                                this.sysconfig.PerBettingPrice
                            ),
                            this.initall.Multiple
                        )
                        )
                    )
                )
        }
    }

    //计算奖金
    //TQQ 2017-01-18
    setRewards(yuanjiaofen: number) {

        this.initall.YuanJiaoFen = yuanjiaofen;
        if (this.initall.currPlayDetail.Algorithm) {
            if (this.initall.currPlayDetail.IsAttached) {
                this.initall.Reward = [];
                let rewardarr = [];
                this.initall.currPlayDetail.PlayDetailAttacheds.forEach(s => {
                    var reward = this.getAttachedReward(s).toFixed(2);
                    this.initall.Reward.push("奖金" + reward);
                    rewardarr.push(reward);
                    this.initall.currPlayDetail.Algorithm.PickExample = this.initall.currPlayDetail.Algorithm.PickExample
                        .replace(/\{\$ + attached.NumKey + 奖金\}/g, reward.toString());
                });
                // $scope.ShowReward = Math.max.apply(null, $scope.Reward);
                // this.initall.ShowReward=this.initall.Reward;
                let list = new List(rewardarr);
                this.initall.ShowReward = list.Max();
                this.filterBonus(rewardarr);
            } else {
                var reward = this.getReward();
                this.initall.currPlayDetail.Algorithm.PickExample = this.initall.currPlayDetail.Algorithm.PickExample
                    .replace('{$奖金}', reward.join('/'));
                if (reward.length > 1) {
                    this.initall.Reward = ['奖金' + reward[0].toFixed(2) + '/' + reward[1].toFixed(2)];
                    this.initall.ShowReward = reward[1];
                } else {
                    this.initall.Reward = ['奖金' + reward[0].toFixed(4)];
                    this.initall.ShowReward = reward[0];
                }
            }
            this.initall.currPlayDetail.Algorithm.TipInfo = this.initall.currPlayDetail.Algorithm.TipInfo.replace('{$位置}', this.initall.currlottery.PlayMode.LotteryPlayModeName);
            this.initall.currPlayDetail.Algorithm.PickExample = this.initall.currPlayDetail.Algorithm.PickExample
                .replace('{$位置}', this.initall.currlottery.PlayMode.LotteryPlayModeName)
                .replace(/\n|\r|(\r\n)|(\u0085)|(\u2028)|(\u2029)/g, '<br/>');

            this.initall.RewardPar = this.initall.Reward[0];
            if (this.initall.Reward.length > 1 || this.initall.RewardPar.indexOf("/") > 0) {
                this.initall.RewardPar = this.initall.RewardPar.substr(0, 8) + "...";
            }
        }
    }

    //扩展奖金
    getAttachedReward(attached) {
        if (this.sysconfig.CanAdjust) {
            // var adjustRewardMode = (this.sysconfig.BasicReward + ((this.initall.currlottery.RewardUp ? this.initall.currlottery.RewardUp : this.sysconfig.RewardUp) - this.sysconfig.RewardUp)) + this.sysconfig.PerGraduation * this.initall.AdjustReward
            // return (attached.CardinalMoney * (adjustRewardMode / 1000) + attached.Modulus) * (this.sysconfig.PerBettingPrice / 4) * this.initall.YuanJiaoFen;
            var adjustRewardMode = this.indexExtend.accAdd(this.indexExtend.accSub(this.indexExtend.accAdd(this.sysconfig.BasicReward, (this.initall.currlottery.RewardUp ? this.initall.currlottery.RewardUp : this.sysconfig.RewardUp)), this.sysconfig.RewardUp), this.indexExtend.accMul(this.sysconfig.PerGraduation, this.initall.AdjustReward));
            return this.indexExtend.accMul(this.indexExtend.accMul(this.indexExtend.accAdd(this.indexExtend.accMul(attached.CardinalMoney, this.indexExtend.accDiv(adjustRewardMode, 1000)), attached.Modulus), this.indexExtend.accDiv(this.sysconfig.PerBettingPrice, 4)), this.initall.YuanJiaoFen)

        } else {
            // return attached.CardinalMoney * (this.sysconfig.PerBettingPrice / 4) * this.initall.YuanJiaoFen;
            this.indexExtend.accMul(this.indexExtend.accMul(attached.CardinalMoney, this.indexExtend.accDiv(this.sysconfig.PerBettingPrice, 4)), this.initall.YuanJiaoFen)
        }
    }

    //无扩展奖金
    getReward() {
        var dev = 1000;
        // if (this.initall.currPlayDetail.IsRewardFixed) {
        //   this.btnAdjustEnable = false;
        // }
        // this.btnAdjustEnable = true;

        var setAdjust;
        var adjustRewardMode;
        if (this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == ("0105")
            || this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == ("0307")
            || this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == ("0309")
            || this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode == ("0108")) {
            if (this.sysconfig.CanAdjust) {
                this.selectAdjust();
                setAdjust = this.initall.AdjustReward;
                adjustRewardMode = this.indexExtend.accAdd(this.initall.baseReward, this.indexExtend.accMul(this.sysconfig.PerGraduation, parseInt(setAdjust)))
                return [
                    this.indexExtend.accMul(this.indexExtend.accMul(this.indexExtend.accAdd(this.indexExtend.accDiv(this.indexExtend.accMul(this.initall.currPlayDetail.CardinalMoney, adjustRewardMode), dev), this.initall.currPlayDetail.Modulus),
                        this.indexExtend.accDiv(this.sysconfig.PerBettingPrice, 4)), this.initall.YuanJiaoFen),
                    this.indexExtend.accMul(this.indexExtend.accMul(this.indexExtend.accAdd(this.indexExtend.accDiv(this.indexExtend.accMul(this.initall.currPlayDetail.CardinalMoney1, adjustRewardMode), dev), this.initall.currPlayDetail.Modulus1),
                        this.indexExtend.accDiv(this.sysconfig.PerBettingPrice, 4)), this.initall.YuanJiaoFen)
                ]
            } else {
                return [(this.initall.currPlayDetail.CardinalMoney * (this.sysconfig.PerBettingPrice / 4) * this.initall.YuanJiaoFen), (this.initall.currPlayDetail.CardinalMoney1 * (this.sysconfig.PerBettingPrice / 4) * this.initall.YuanJiaoFen)];
            }
        }

        if (this.sysconfig.CanAdjust) {
            this.selectAdjust();
            setAdjust = this.initall.AdjustReward;
            // adjustRewardMode = this.initall.baseReward + this.sysconfig.PerGraduation * parseInt(setAdjust);
            adjustRewardMode = this.indexExtend.accAdd(this.initall.baseReward, this.indexExtend.accMul(this.sysconfig.PerGraduation, parseInt(setAdjust)));
            // return [(this.initall.currPlayDetail.CardinalMoney * (adjustRewardMode / dev) + this.initall.currPlayDetail.Modulus)
            //     * (this.sysconfig.PerBettingPrice / 4) * this.initall.YuanJiaoFen];
            // console.log([(this.initall.currPlayDetail.CardinalMoney * (adjustRewardMode / dev) + this.initall.currPlayDetail.Modulus)
            //     * (this.sysconfig.PerBettingPrice / 4) * this.initall.YuanJiaoFen])
            // console.log(this.initall.currPlayDetail.CardinalMoney, adjustRewardMode, dev, this.initall.currPlayDetail.Modulus, this.sysconfig.PerBettingPrice, this.initall.YuanJiaoFen)
            return [
                this.indexExtend.accMul(this.indexExtend.accMul(
                    this.indexExtend.accAdd(this.indexExtend.accMul(this.initall.currPlayDetail.CardinalMoney, this.indexExtend.accDiv(adjustRewardMode, dev)), this.initall.currPlayDetail.Modulus),
                    this.indexExtend.accDiv(this.sysconfig.PerBettingPrice, 4)), this.initall.YuanJiaoFen)
            ]
        } else {
            return [this.indexExtend.accMul(this.indexExtend.accMul(this.initall.currPlayDetail.CardinalMoney, this.indexExtend.accDiv(this.sysconfig.PerBettingPrice, 4)), this.initall.YuanJiaoFen)]
            // return [(this.initall.currPlayDetail.CardinalMoney * (this.sysconfig.PerBettingPrice / 4) * this.initall.YuanJiaoFen)];
        }
    };

    selectAdjust() {
        var setAdjust = this.initall.AdjustReward;
        var curretBonus = this.currUser.Bonus - (setAdjust * this.sysconfig.BonusGruduation);
        curretBonus = curretBonus < 0 ? 0 : curretBonus;
        if (this.sysconfig.AdjustMaxBonus < curretBonus
            || this.sysconfig.AdjustMinBonus > curretBonus) {
            setAdjust = 0;
            this.initall.AdjustReward = setAdjust;
        }

        var curretRewiteMode = this.initall.baseReward
            + this.sysconfig.PerGraduation * setAdjust;
        var jiaoAdjust = (this.sysconfig.JiaoMaxMode
            - this.initall.baseReward) / this.sysconfig.PerGraduation;
        var fenAdjust = (this.sysconfig.FenMaxMode
            - this.initall.baseReward) / this.sysconfig.PerGraduation;
        if (this.initall.YuanJiaoFen == 0.1) {
            if (curretRewiteMode > this.sysconfig.JiaoMaxMode) {
                setAdjust = jiaoAdjust;
                this.initall.AdjustReward = setAdjust;
            }
        } else if (this.initall.YuanJiaoFen == 0.01) {
            if (curretRewiteMode > this.sysconfig.FenMaxMode) {
                setAdjust = fenAdjust;
                this.initall.AdjustReward = setAdjust;
            }
        }

        if (curretRewiteMode > this.initall.rewardUp) {
            setAdjust = 0;
            this.initall.AdjustReward = setAdjust;
        } else if (curretRewiteMode < this.initall.rewardDown) {
            setAdjust = 0;
            this.initall.AdjustReward = setAdjust;
        }
    };

    //投注倍数自增
    //chen 2017-01-18
    add() {
        this.initall.Multiple++;
        this.getPageReward();
    }

    //投注倍数自减
    //chen 2017-01-18
    sub() {
        if (this.initall.Multiple > 1) {
            this.initall.Multiple--;
        } else {
            this.initall.Multiple = 1;
        }
        this.getPageReward();
    }

    //返点调节出现
    //chen 2017-01-18
    range() {
        this.initall.rangeFlag = !this.initall.rangeFlag;
    }


    //添加投注
    //TQQ 2017-01-10
    //type 0添加投注 1一键投注
    addOrder(isonebet = false, type = 0) {
        if (this.initall.checkList.length > 0) {
            if (this.initall.currPlayDetail.Algorithm.BetNumLength <= 5 && this.initall.checkList.filter(s => s.checked).length < this.initall.currPlayDetail.Algorithm.BetNumLength) {
                this.alert.showAlert('必须选择' + this.initall.currPlayDetail.Algorithm.BetNumLength + '个位数');
                return false;
            }
        }

        if (this.initall.currPlayDetail.IsAttached) {
            if (this.initall.BettingCount > 0 && this.initall.ShowReward * this.initall.Multiple > this.sysconfig.PerMaxReward && type == 0 && this.perMaxReward) {
                this.alert.showConfirm('奖金可能超过限额' + this.sysconfig.PerMaxReward + '，是否继续投注？', s => {
                    return this.addorderIsContinue(isonebet);
                });
            }
            else {
                return this.addorderIsContinue(isonebet);
            }
        } else {
            if (this.initall.ShowReward * this.initall.Multiple > this.sysconfig.PerMaxReward && this.perMaxReward) {
                this.alert.showAlert('奖金超限');
                return false;
            }
            return this.addorderIsContinue(isonebet);
        }
    }

    addorderIsContinue(isonebet = false) {
        if (this.initall.currPlayDetail.Algorithm.AlgorithmType.PickMode == '01') {
            var par = {
                dataSel: this.initall.data_sel,
                lotteryTypeCode: this.initall.currlottery.LotteryTypeCode,
                checklist: this.initall.checkList,
                algorithmTypeCode: this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode,
                betNumLength: this.initall.currPlayDetail.Algorithm.BetNumLength,
                isrx: this.initall.isrx
            }
            this.initall.BettingCount = this.bettinghelper.getCurrentLotteryBetCount(par);
            this.getPageReward();
            if (this.initall.BettingCount == 0 && !isonebet) {
                this.alert.showAlert("选号有误！");
                return false;
            }

            var selectNum = this.bettinghelper.getLotteryNum(this.initall.data_sel, this.initall.currPlayDetail.Algorithm.AlgorithmTypeCode);
            if (!this.isAgainNum(selectNum)) {
                return false;
            }
            this.AddBetData(selectNum, this.initall.BettingCount, false, this.initall.medianList, this.initall.YuanJiaoFen, this.initall.Multiple);
        } else if (this.initall.currPlayDetail.Algorithm.AlgorithmType.PickMode == '02') {
            var result;
            if (this.initall.BettingCount === 0 && !isonebet) {
                this.alert.showAlert("选号有误！");
                return false;
            }
            result = this.bettinghelper.getErrorBettingNumber(this.initall.BetBoxNum, this.initall.currlottery.LotteryTypeCode, this.initall.currPlayDetail);
            if (this.initall.BetBoxNum == "" && !isonebet) {
                this.alert.showAlert("请输入号码！");
                return false;
            }
            var strArray = result.correct;
            if (this.initall.currlottery.LotteryTypeCode == ("02")) {
                for (var i = 0; i < strArray.length; i++) {
                    if (strArray[i] == "" || typeof (strArray[i]) == "undefined") {
                        strArray.splice(i, 1);
                        i = i - 1;
                    }
                }
            } else {
                for (var i = 0; i < strArray.length; i++) {
                    if (strArray[i] == "" || typeof (strArray[i]) == "undefined") {
                        strArray.splice(i, 1);
                        i = i - 1;
                    }
                }
            }

            if (strArray.length > 0) {
                var cnt = strArray.length;
                var checkedlength = 0;
                let list = new List(this.initall.checkList);
                checkedlength = list.Where(s => s.checked).ToArray().length;
                if (this.initall.isrx && checkedlength > 0) {
                    cnt *= checkedlength == 0 ? 0 : MathAlgorithm.Combination(checkedlength, this.initall.currPlayDetail.Algorithm.BetNumLength);
                }
                if (!this.isAgainNum(strArray.join(','))) {
                    return false;
                }
                this.AddBetData(strArray.join(','), cnt, true, this.initall.medianList, this.initall.YuanJiaoFen, this.initall.Multiple);
            }

            if (result.errorlist.length > 0) {
                var errornum;
                if (result.errorlist.length <= 20) {
                    errornum = result.errorlist.join(',');
                } else {
                    errornum = result.errorlist.slice(0, 20).join(',') + ' ... ...';
                }
                this.alert.showAlert("以下号码有错误或重复，已自动过滤" + errornum);
            }
        }
        for (var n in this.initall.medianList) {
            this.initall.numList[n].forEach(v => {
                this.unSelectNum(v);
            });
        }
        this.initall.BetBoxNum = "";
        return true;
    }
    //判断是否有重复注单
    //TQQ 2017-08-29
    isAgainNum(currNum) {
        if (this.initall.BetDatas && this.initall.BetDatas.length > 0) {
            //倍数，注数，模式，投注号码，玩法
            let list = new List(this.initall.BetDatas);
            let betFilter = list.Where(s => s.multiple === this.initall.Multiple && s.bettingCount === this.initall.BettingCount
                && s.yuanjiaofen === this.initall.YuanJiaoFen && s.selectNum === currNum
                && (s.lotteryCode === this.initall.currlottery.LotteryCode && s.playMode === this.initall.currlottery.PlayMode && s.playDetail === this.initall.currPlayDetail))
                .ToArray();
            if (betFilter && betFilter.length > 0) {
                this.alert.showAlert('重复注单，请重试');
                return false;
            }
        }
        return true;
    }


    //购物车
    //TQQ 2017-01-10
    buycar() {
        let para = {
            orders: this.initall.BetDatas,
            lotteryName: this.initall.currlottery.LotteryName,
            lotteryCode: this.lotteryCode,
            currIssue: this.initall.currIssue,
            playDetail: this.initall.currPlayDetail,
            adjustReward: this.initall.AdjustReward,
            rewardUp: this.initall.rewardUp,
            rewardDown: this.initall.rewardDown,
            baseReward: this.initall.baseReward,
            currUserMoney: this.currUser.UserMoney
        };
        this.navCtrl.push(BettingOrderAdd, para);


        for (var i in this.initall.medianList) {
            this.initall.numList[i].forEach(v => {
                this.unSelectNum(v);
            });
        }
    }

    AddBetData(selectNum, bettingCount, isInput, selectMedian, yuanjiaofen, multiple) {
        var yuanjiaofenname = '元';
        if (yuanjiaofen == 0.1) {
            yuanjiaofenname = '角';
        } else if (yuanjiaofen == 0.01) {
            yuanjiaofenname = '分';
        } else if (yuanjiaofen == 0.001) {
            yuanjiaofenname = '厘';
        }
        var median = [];
        this.initall.medianList.forEach(s => {
            median.push(s.name);
        });

        var betData = {
            ruleName: this.initall.currlottery.PlayMode.LotteryPlayModeName + '_' + this.initall.currPlayDetail.LotteryPlayDetailName,
            selectNum: selectNum,
            bettingCount: bettingCount,
            multiple: multiple,
            yuanjiaofen: yuanjiaofen,
            isRewardFixed: this.initall.currPlayDetail.IsRewardFixed,
            GraduationCount: 0,
            lotteryPlayDetailCode: this.initall.currPlayDetail.LotteryPlayDetailCode,
            SelectMedian: this.bettinghelper.getSelectMedian("code", this.initall.checkList, this.initall.currlottery.LotteryTypeCode),
            perBettingPrice: this.sysconfig.PerBettingPrice,
            lotteryCode: this.lotteryCode,
            playMode: this.initall.currlottery.PlayMode,
            playDetail: this.initall.currPlayDetail
        };

        if (betData.isRewardFixed) {
            betData.GraduationCount = this.initall.AdjustRewardIsFix;
        } else {
            betData.GraduationCount = this.initall.AdjustReward;
        }
        if (betData.bettingCount > 0) {
            this.initall.BetDatas.push(betData);
        }
    }


    //帮助
    //TQQ 2017-01-20
    helperClick() {
        this.alert.showAlert(this.initall.currPlayDetail.Algorithm.TipInfo, this.initall.currPlayDetail.Algorithm.PickExample, false);
    }

    //一键投注
    //TQQ 2017-01-23
    //type :0添加投注，1一键投注
    oneKeyBet(type = 1) {
        if (type == 1) {
            if (this.addOrder(true, type) == false) {
                return;
            }
        }
        if (this.initall.currPlayDetail.IsAttached) {
            if (this.initall.BettingCount > 0 && this.initall.ShowReward * this.initall.Multiple > this.sysconfig.PerMaxReward && type == 1 && this.perMaxReward) {
                this.alert.showConfirm('奖金可能超过限额' + this.sysconfig.PerMaxReward + '，是否继续投注？', s => {
                    this.submitorder();
                }, '提示', cancel => {
                    this.initall.BetDatas.pop();
                });
            } else {
                this.submitorder();
            }
        } else {
            this.submitorder();
        }
    }

    submitorder() {
        if (this.tingPanStatus || this.initall.currIssue.CurrentIssueNo == "-1") {
            this.alert.showAlert("当前彩种停盘中");
            return;
        }
        if (this.initall.BetDatas.length < 1) {
            this.alert.showAlert("请先点击添加，再进行投注！");
            return;
        }

        let orders = this.initall.BetDatas;
        let errors = [];
        let ajaxList = [];

        let load = this.loadding.showLoding("投注中...");
        orders.forEach(o => {
            var b = {
                BettingCount: o.bettingCount,
                BettingMoney: (o.bettingCount * o.multiple * o.yuanjiaofen * o.perBettingPrice).toFixed(4),
                BettingNumber: o.selectNum,
                GraduationCount: o.GraduationCount,
                IsChaseNo: false,
                IssueNo: this.initall.currIssue.CurrentIssueNo,
                LotteryCode: this.lotteryCode,
                LotteryPlayDetailCode: o.lotteryPlayDetailCode,
                Multiple: o.multiple,
                RuleName: o.ruleName,
                SelectMedian: o.SelectMedian,
                BettingInfoIssueList: [{
                    IssueNo: this.initall.currIssue.CurrentIssueNo,
                    Multiple: o.multiple,
                    PerPrice: o.perBettingPrice * o.yuanjiaofen
                }],
                BuyIssueCount: 0
            };
            b.BuyIssueCount = b.BettingInfoIssueList.length;
            ajaxList.push(this.bettingService.betting(b));

        });
        ajaxList.forEach(r => {
            r.then(s => {
                if (!s.Result) {
                    errors.push(s);
                }
            });
        });

        Promise.all(ajaxList).then(() => {
            if (errors.length > 0) {
                var errorhtml = [];
                errors.forEach(e => {
                    errorhtml.push(e.Error);
                });
                this.alert.showAlert(errorhtml.join(''));
            } else {
                this.initall.BetDatas = [];
                this.alert.showAlert("投注成功");
                for (var n in this.initall.medianList) {
                    this.initall.numList[n].forEach(v => {
                        this.unSelectNum(v);
                    });
                }
                this.initall.BetBoxNum = "";
            }
            this.loadding.closeLoading(load);
        }).catch(c => {
            this.loadding.closeLoading(load);
        });
    }

    //追号
    //TQQ 2017-01-23
    chaseClick() {
        this.addOrder(true);
        if (this.checkPlayHasMultiRule(this.initall.BetDatas)) {
            this.alert.showAlert("不可追号！");
            return;
        }
        if (this.initall.BetDatas.length <= 0) {
            this.alert.showAlert("投注列表没有可以追号的订单！");
            return;
        }
        if (this.initall.BetDatas.length > 1) {
            this.alert.showAlert("多注单不可追号！");
            return;
        }
        var para = {
            playType: 0,
            currIssue: this.initall.currIssue,
            order: this.initall.BetDatas[0],
            lotteryCode: this.lotteryCode,
            lotteryName: this.initall.currlottery.LotteryName,
            playDetail: this.initall.currPlayDetail,
            adjustReward: this.initall.AdjustReward,
            rewardUp: this.initall.rewardUp,
            rewardDown: this.initall.rewardDown,
            baseReward: this.initall.baseReward
        }
        this.navCtrl.push(BettingChase, para);
    }

    //检查是否添加的投注是否有多种玩法
    checkPlayHasMultiRule(betData) {
        if (!Array.isArray(betData)) {
            return;
        }
        var isMulti = false;
        var checkData = [];
        var checkDataLength = 0;
        betData.forEach(s => {
            checkData[s.lotteryPlayDetailCode] = true;
        });
        checkData.forEach(s => {
            ++checkDataLength;
        });
        if (checkDataLength > 1) {
            isMulti = true;
        }
        return isMulti;
    }


    //隐藏与否
    //chen 2017-01-24
    change(event) {
        this.changeFalg = false;
        this.flagChange = !this.flagChange;
        this.initall.isShowOpen = false;

        let detailName = this.popTranks["playDetailName"] ? this.popTranks["playDetailName"] : this.initall.currPlayDetail.LotteryPlayDetailName;
        let playgroup = this.popTranks["PlayGroup"] ? this.popTranks["PlayGroup"] : this.initall.currPlayDetail.PlayGroup;

        let popover = this.popCtrl.create(PlaySelectPage, {
            currlottery: this.initall.currlottery,
            currPlayDetailName: detailName,
            PlayGroup: playgroup,
            lotteryCode: this.lotteryCode
        }, { cssClass: "playSelect" });
        popover.present({ ev: event });
        popover.onWillDismiss((data: any[]) => {
            this.flagChange = false;
            if (data) {
                this.popTranks = data;
                let playMode = this.popTranks["playMode"];
                let playDetail = this.popTranks["playDetail"] ? this.popTranks["playDetail"] : this.initall.currPlayDetail;
                if (playMode) {
                    this.initall.currlottery.PlayMode = this.playOfficialModes.PlayModes.find(s => s.LotteryPlayModeCode == playMode.LotteryCode);
                }
                this.currPlayDetaileCode = playDetail.LotteryPlayDetailCode;
                this.cacheds = this.storage.read<CachedModel[]>("cachedPlay" + this.lotteryCode);
                this.cacheds = this.cacheds ? this.cacheds : [];
                this.initall.currlottery.PlayMode = playMode;
                this.selectionResult = playMode.LotteryPlayModeName + "---" + (this.popTranks["playDetailName"] ? this.popTranks["playDetailName"] : detailName);
                this.initPlayDetail(playDetail);
            }
        })
    }
    //记忆玩法点击
    //chen 2018-03-23
    cachedSele(obj) {
        this.initall.currlottery.PlayMode = this.initall.currlottery.PlayModes.find(s => s.LotteryPlayModeCode == obj.PlayMode.LotteryCode);
        this.initPlayDetail(obj.PlayDetail);
    }
    //显示奖金
    //TQQ 2017-02-20
    presentPopover(ev) {
        let popover = this.popCtrl.create(RewardPage, { rewards: this.initall.Reward });
        popover.present({
            ev: ev
        });
    }
    //显示余额
    oprinerLet(event) {
        let popover = this.popCtrl.create(UserMoneyPage)
        popover.present({
            ev: event
        });
    }
    //打开/关闭 提示音
    //TQQ 2017-02-27
    openWarn() {

        this.initall.OpenWarn = this.initall.OpenWarn == this.initall.WarnUp ? this.initall.WarnOff : this.initall.WarnUp;
        this.soundState = !this.soundState;
        // this.cookie.remove('openSound');
        this.storage.write("openSound", '');
        if (this.soundState) {
            // this.cookie.put('openSound', 'notifications');
            this.storage.write("openSound", 'on');
        } else {
            // this.cookie.put('openSound', 'notifications-off');
            this.storage.write("openSound", 'off');
        }
    }

}

export class InitParams {
    formatRemain = "00:00:00";
    openIssueno = "";
    openNum = "";
    currlottery = new CurrLotteryModel();
    currIssue = new CurrIssue();
    medianList = [];
    numList = [];
    commandList = [];
    checkList = [];
    data_sel = [];
    BettingCount = 0;
    Multiple = 1;//倍数
    YuanJiaoFen = 1;//元角分厘
    currPlayDetail = new PlayDetailModel();
    currAlgorithmType = new AlgorithmTypeModel();
    isrx = false;
    Reward = [];
    RewardPar = "";//显示奖金部分
    ShowReward = 0;
    AdjustReward = 0;
    rewardUp = 0;
    rewardDown = 0;
    baseReward = 0;
    BetBoxNum = "";
    maxnum = 0;
    minnum = 0;
    rangeValue = 0;
    BonusMode = [];
    rangeFlag = false;
    AdjustRewardIsFix = 0;
    BetDatas = [];
    historyList = [];
    isShowOpen = false;
    isOk = true;//无catch
    OpenWarn = "notifications";//是否有声音提示
    WarnUp = "notifications";
    WarnOff = "notifications-off";

    constructor() {
        this.currIssue = new CurrIssue();
        this.currlottery = new CurrLotteryModel();
        this.currPlayDetail = new PlayDetailModel();
        this.currAlgorithmType = new AlgorithmTypeModel();
    }

    initDetailPars() {
        this.medianList = [];
        this.numList = [];
        this.commandList = [];
        this.checkList = [];
        this.data_sel = [];
        this.BettingCount = 0;
        this.isrx = false;
    }

}



// WEBPACK FOOTER //
// ./src/pages/bettingorder/bettingorder.ts